import { message } from "antd";
import ls from "utils/ls";

const actions = (dispatch) => ({
  login: (token, studentInfo) => {
    ls.set("studentInfo", studentInfo);
    dispatch({ type: "LOGIN", token: token, studentInfo: studentInfo });
  },
  // Серверээс ирсэн шинэ профайлыг хадгалах (код/анги солигдсон үед дахин нэвтрэхгүйгээр шинэчлэгдэнэ)
  refreshProfile: (profile) => {
    const info = ls.get("studentInfo");
    if (!info || !profile) return;
    const next = { ...info, profile: { ...info.profile, ...profile } };
    ls.set("studentInfo", next);
    dispatch({ type: "LOGIN", token: next.token, studentInfo: next });
  },
  logout: async () => {
    ls.remove("studentInfo");
    dispatch({ type: "LOGOUT" });
  },
  onSuccess: (info) => {
    message.open({ type: "success", content: info });
  },
  onError: (info) => {
    message.open({ type: "error", content: info });
  },
});

export default actions;
